<script>
import Base from "@/components/RequestDetailsCustomerService/AgentData.vue";

export default {
  name: "CustomerServiceFilesAgentData",
  extends: Base,
};
</script>
